import { useLocation, useNavigate } from 'react-router-dom';
import { Icon } from '../components/Icon';
import { useSession } from '../lib/session';

/**
 * Pantalla puente para las áreas cuya interfaz aún se está construyendo.
 * No finge: si el área está cerrada para esta empresa, explica por qué y ofrece
 * la acción de desbloqueo; si está disponible, la presenta como una invitación.
 */
export function ModulePlaceholder() {
  const { caps } = useSession();
  const loc = useLocation();
  const nav = useNavigate();

  const item = caps?.navigation
    .flatMap((s) => s.items)
    .find((i) => loc.pathname === i.route || loc.pathname.startsWith(i.route + '/'));

  const label = item?.label ?? 'Module';
  const locked = item ? !item.enabled : false;

  return (
    <main className="main">
      <div className="page-head">
        <div className="page-head__title">
          <span className="eyebrow">{locked ? 'Área cerrada' : 'Under construction'}</span>
          <h1 className="h1">{label}</h1>
        </div>
      </div>

      <div className="card">
        <div className="card__body" style={{ padding: 48, textAlign: 'center' }}>
          <div
            style={{
              width: 52,
              height: 52,
              margin: '0 auto 18px',
              borderRadius: 14,
              display: 'grid',
              placeItems: 'center',
              background: 'var(--card-sunken)',
              color: locked ? 'var(--clay)' : 'var(--accent)',
            }}
          >
            <Icon name={locked ? 'lock' : 'compass'} size={24} />
          </div>

          {locked ? (
            <>
              <h2 className="h2" style={{ marginBottom: 8 }}>Not available here yet</h2>
              <p className="muted" style={{ maxWidth: '46ch', margin: '0 auto 20px' }}>
                {item?.lockedReason ?? 'Your plan or license does not include this module for now.'}
              </p>
              <button className="btn btn--accent" onClick={() => nav('/objetivos')}>
                View in objectives
                <Icon name="arrow-right" size={16} />
              </button>
            </>
          ) : (
            <>
              <h2 className="h2" style={{ marginBottom: 8 }}>Estamos terminando esta pantalla</h2>
              <p className="muted" style={{ maxWidth: '48ch', margin: '0 auto 20px' }}>
                El motor y los datos de <b>{label.toLowerCase()}</b> ya funcionan en el backend. La
                interfaz llega en la siguiente entrega.
              </p>
              <button className="btn btn--ghost" onClick={() => nav('/')}>
                Volver al panel
              </button>
            </>
          )}
        </div>
      </div>
    </main>
  );
}
